import React from "react"
import DefaultBtn from "./DefaultBtn"


export default class RestartBtn extends React.Component {

  render() {
    return (
      <DefaultBtn 
      handleClick={this.props.handleClick} 
      type="btn-restart" 
      inner={this.props.inner}
      />
    )
  }
}